import { computed, effect, inject, Injectable, signal } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TokenService } from "../../auth/services/token.service";
import { BehaviorSubject, Observable } from "rxjs";
import { LoginForm } from "../../shared/data-types/login-form";
import { environment } from "../../../environments/environment";
import { UserRole } from "../../shared/data-types/roles.enum";
import { User } from "../../shared/models/user";
import { UserService } from "../../auth/services/user.service";
import { AuthStore } from "../../shared/store/auth.store";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  // todo: change env for prod, o implementar logica a eso
  private baseUrl = environment.apiUrl;

  private authStore = inject(AuthStore);

  constructor(private http: HttpClient, private tokenService: TokenService) {}

  /** Registrar un usuario */
  registerUser(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/register`, data, { responseType: "json" });
  }

  /** Iniciar sesión */
  loginUser(data: LoginForm): Observable<any> {
    if (this.tokenService.isTokenValid()) {
      this.tokenService.removeToken();
    }

    const formData = new URLSearchParams();
    formData.set("username", data.email);
    formData.set("password", data.password);

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return this.http.post<any>(`${this.baseUrl}/auth/login`, formData.toString(), { headers });
  }

  /** Manejar el éxito del login */
  handleLoginSuccess(token: string): void {
    this.tokenService.setToken(token);
  }

  /** Verificar si el usuario está autenticado */
  isAuthenticated(): boolean {
    return this.tokenService.getToken() != null && this.tokenService.isTokenValid();
  }

  /** Cerrar sesión */
  logout(): void {
    this.tokenService.removeToken();
  }

  /** Obtener los roles del usuario */
  getUserRoles(): UserRole[] {
    const token = this.tokenService.getToken();
    if (!token) {
      return [];
    }

    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.authorities || [];
  }
}
